// companiesSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllCustomersList, customerMasters } from "../../config/Services/Userservices";
import {
  filterByKeyValue,
  getCustomerAccountGroup,
  normalizeCustomerDetailItem,
  normalizeCustomerDetailItems,
} from "../../config/utilityFunctions";

export const fetchCustomerDetails = createAsyncThunk(
  "fmcg/fetchCustomerDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const role = payload?.role || localStorage.getItem("role");
      let response;

      if (role === "Parent") {
        const bpCode = payload?.bp_code || localStorage.getItem("bpCode");
        const parentPayload = {
          Request_Data: {
            bp_code: bpCode,
            role: "Parent"
          }
        };
        response = await customerMasters(parentPayload);

        // Normalize Parent response to match /customer_details format
        // Handle various possible response keys
        const rawData = response?.data?.CUSTOMERS_PARENT?.CUSTOMERS_PARENTType ||
          response?.data?.CUSTOMERS_BP?.CUSTOMERS_BPType ||
          response?.data?.CUSTOMERS_MANAGER?.CUSTOMERS_MANAGERType || [];
        const items = Array.isArray(rawData) ? rawData : [rawData];

        return {
          Response_Data: {
            item: items.map((c) =>
              normalizeCustomerDetailItem({
                CustomerCode: c.CustomerNo,
                CustomerName: c.CustomerName,
                LOB: c.LOB_Text || "NBD",
                LOB_Text: c.LOB_Text || "NBD",
                Account_Group: getCustomerAccountGroup(c),
                accountGroup: getCustomerAccountGroup(c),
              })
            ),
          },
        };
      } else {
        response = await getAllCustomersList(payload);
        return response.data;
      }
    } catch (error) {
      const errorMessage = error.response ? error.response.data : error.message;
      console.error("Fetch customer details failed:", errorMessage);
      return rejectWithValue({ error: errorMessage });
    }
  }
);

const companiesSlice = createSlice({
  name: "companies",
  initialState: {
    allCompanies: [],
    currentCompany: null,

    //Customer List
    customerDetails: [],
    customersList: [],
    customersList_Leap: [],
    customersList_Taron: [],
    customersList_CHEP: [],
    customersList_FMCG: [],
    customersList_Auto: [],
    customersList_MHE: [],
    customersList_NBD: [], // Added NBD list
    customersloading: false,
    customersError: null,
  },
  reducers: {
    setCompanies: (state, action) => {
      state.allCompanies = action.payload;
    },
    setCurrentCompany: (state, action) => {
      state.currentCompany = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerDetails.pending, (state) => {
        state.customersloading = true;
        state.customersError = null;
      })
      .addCase(fetchCustomerDetails.fulfilled, (state, action) => {
        state.customersloading = false;
        const normalizedItems = normalizeCustomerDetailItems(
          action?.payload?.Response_Data?.item
        );

        if (normalizedItems.length === 1) {
          state.customerDetails = normalizedItems;
        } else {
          state.customerDetails = [];
          state.customersList = normalizedItems;

          // Filter ALL customers from getAllCustomersList API
          state.customersList_FMCG = filterByKeyValue(
            normalizedItems,
            "LOB",
            "FMCG"
          );
          state.customersList_Auto = filterByKeyValue(
            normalizedItems,
            "LOB",
            "AUTO"
          );
          state.customersList_MHE = filterByKeyValue(
            normalizedItems,
            "LOB",
            "MHE"
          );
          // Filter NBD customers from the same API
          state.customersList_NBD = filterByKeyValue(
            normalizedItems,
            "LOB",
            "NBD"
          );

          console.log("📊 Redux - FMCG customers:", state.customersList_FMCG?.length || 0);
          console.log("📊 Redux - AUTO customers:", state.customersList_Auto?.length || 0);
          console.log("📊 Redux - NBD customers:", state.customersList_NBD?.length || 0);
          console.log("📊 Redux - MHE customers:", state.customersList_MHE?.length || 0);

          // Log first NBD customer for debugging
          if (state.customersList_NBD?.length > 0) {
            console.log("📊 First NBD customer:", state.customersList_NBD[0]);
          }
        }
      })
      .addCase(fetchCustomerDetails.rejected, (state, action) => {
        state.customersloading = false;
        state.customersError = action.payload;
      });
  },
});

export const { setCompanies, setCurrentCompany } = companiesSlice.actions;
export default companiesSlice.reducer;